import { render } from "./BusinessProfile.vue?vue&type=template&id=17d8092d&scoped=true"
import script from "./BusinessProfile.vue?vue&type=script&lang=js"
export * from "./BusinessProfile.vue?vue&type=script&lang=js"

import "./BusinessProfile.vue?vue&type=style&index=0&id=17d8092d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d8092d"]])

export default __exports__